export const api = `${process.env.REACT_APP_API_URL}/api/v1/user/account/`;
